import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GetApp from "../components/GetApp";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About Us</title>
        <link rel="canonical" href="https://boque.me/about" />
        <meta
          name="description"
          content="Our Vision - To be the go-to platform for seamless and stylish nail care experiences, empowering individuals to access top-notch nail services effortlessly while enabling nail experts to thrive."
        />
      </Helmet>
      <div
        className="header"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col md={8}>
              <h1>Our Vision</h1>
              <p className="mt-3 fs-4">
                To be the go-to platform for seamless and stylish nail care
                experiences, empowering individuals to access top-notch nail
                services effortlessly while enabling nail experts to thrive.
              </p>
            </Col>
            <Col md={4}>
              <h1>The Mission</h1>
              <p className="mt-3 fs-4">
                To connect nail enthusiasts with skilled professionals through a
                user-friendly platform, fostering convenience, creativity, and
                exceptional customer satisfaction. Boque is dedicated to
                redefining the nail care industry by empowering experts and
                delivering personalized experiences for every user.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="mt-3">
          <Col sm={12}>
            <strong>How it Started?</strong>
            <p>
              Boque began with a simple idea: to bridge the gap between nail
              care enthusiasts and skilled professionals. Recognizing the
              growing demand for personalized, high-quality nail services, we
              envisioned a platform that simplifies booking appointments while
              providing professionals with tools to manage and grow their
              businesses. Inspired by the vibrant nail care community and the
              need for convenience in a fast-paced world, we set out to create a
              solution that caters to both customers and experts.
            </p>
            <strong>Why it Started?</strong>
            <p>
              Boque was founded to address two major challenges in the nail care
              industry:
              <p>
                <strong>For Customers:</strong> The hassle of finding reliable
                nail experts and booking appointments that fit their schedules.
              </p>
              <p>
                <strong>For Professionals:</strong>
                The lack of accessible platforms to showcase their expertise,
                attract clients, and streamline their operations.{" "}
              </p>
              By launching Boque, we aim to transform nail care into an
              effortless and enjoyable experience while empowering professionals
              to succeed in a competitive market. Its about convenience,
              creativity, and connection—all at your fingertips.
            </p>
          </Col>
        </Row>
      </Container>
      <GetApp />
    </>
  );
};

export default About;
